import React, { useMemo } from "react";
import { Column } from "react-table";

import { Invoice } from "types/invoice";
import { DataTable, SelectFilter } from "components";
import InvoiceRow from "./InvoiceRow";

interface Props {
  invoices: Invoice[];
}

const InvoicesDataTable: React.FC<Props> = ({ invoices }: Props) => {
  const data: Invoice[] = useMemo(() => invoices, [invoices]);
  const columns: Column<Invoice>[] = useMemo(
    () => [
      {
        accessor: "id",
        disableSortBy: true,
        Cell: ({ row: { original } }: any) => <InvoiceRow invoice={original} />
      },
      {
        Header: "Invoice Number",
        accessor: "invoice_num"
      },
      {
        Header: "Amount",
        accessor: "amount"
      },
      {
        Header: "Due Date",
        accessor: "due"
      },
      {
        Header: "Status",
        accessor: "status",
        Filter: SelectFilter,
        filter: "equals"
      }
    ],
    []
  );

  return <DataTable columns={columns} data={data} tableTitle="Invoices" />;
};

export default InvoicesDataTable;
